import { Link } from "react-router-dom";
function Footer() {
  return (
    <>
      <footer>
        <div className="footer-container">
          <div className="logo-container"></div>
          <div className="text-container">
            <Link to={"/services"}>Services</Link>
            <Link to={"/Contact"}>Contact</Link>
            <Link to={"/FAQ"}>FAQ</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2024 Lemaire Plomberie des Weppes. tous droits réservés.</p>
          <Link to={"/mandatoryInformation"}> Mentions Légales</Link>
        </div>
      </footer>
    </>
  );
}

export default Footer;
